import * as React from "react"
import {Box, Typography} from "@mui/material";


export default function PricingSkuInfoBlock({ sku, category, brand, ean }) {
	return <Box>
		<Typography variant="caption">
			{sku}
		</Typography>
		<Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
			Category: {category}
		</Typography>
		<Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
			Brand: {brand}
		</Typography>
		{ !!ean && <Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
			EAN: {ean}
		</Typography> }
	</Box>
}